// authenticationSlice.js
import { jwtDecode } from 'jwt-decode'
import { createSlice } from '@reduxjs/toolkit';
import { forgotPassword, getUserList, login, loginWithOTP, logout, resetPassword, verifyWithOTP } from '../../builders/auth/auth.builders';

// Define the initial state
const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  pageModeOtp: 'number',
  userRole: null,
  userList: [],
  userPhone: null,
  forgotEmail: null,
  userOtp: null,
  // accessToken: null,
  // refreshToken: null,
  status: 'idle',
  secondsRemaining: null,
  timeRemaining: null
};

// Define the authentication slice
const authenticationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setPageModeOtp: (state, action) => {
      state.pageModeOtp = action.payload
    },
    setUserData: (state, action) => {
      state.user = action.payload
    },
    setUserToken: (state, action) => {
      state.token = action.payload
      const decodedAccessToken = jwtDecode(action.payload)
      state.userRole = decodedAccessToken.userRole
    },
    setUserPhone: (state, action) => {
      state.userPhone = action.payload
    },
    setUserEmail: (state, action) => {
      state.forgotEmail = action.payload
    },
    setUserOtp: (state, action) => {
      state.userOtp = action.payload
    },
    setTimeRemaining(state) {
      state.timeRemaining = state.timeRemaining - 1;
    },
    // logoutToken: (state) => {
    //   state.accessToken = null;
    //   state.refreshToken = null;
    // },
    clearExtraReducers: (state) => {
      state.loading = false;
      state.error = null;
      state.pageModeOtp = 'number';
      state.userRole = null;
      state.userList = [];
      state.user = null;
      state.token = null
      state.userPhone = null,
      state.userOtp = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        // state.token = action.payload
        // state.accessToken = action.payload.accessToken;
        // state.refreshToken = action.payload.refreshToken;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        // state.user = null;
        state.error = action.error.message;
      })
      // .addCase(refreshToken.fulfilled, (state, action) => {
      //   state.accessToken = action.payload.accessToken;
      //   state.refreshToken = action.payload.refreshToken;
      // })
      .addCase(loginWithOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginWithOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.accessToken = action.payload;
        state.secondsRemaining = 60;
        state.timeRemaining = 60;
        state.error = null;
      })
      .addCase(loginWithOTP.rejected, (state, action) => {
        state.loading = false;
        // state.user = null;
        state.error = action.error.message;
      })
      .addCase(verifyWithOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyWithOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(verifyWithOTP.rejected, (state, action) => {
        state.loading = false;
        // state.user = null;
        // state.secondsRemaining = 0;
        state.error = action.error.message;
      })
      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.error = action.error.message;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.error = action.error.message;
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null
        state.token = null
        state.userPhone = null
        state.error = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.error = action.error.message;
      })
      .addCase(getUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.userList = action.payload
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.error = action.error.message;
      });
  },
});

// Export actions and reducer
export const { setPageModeOtp, setUserData, setUserToken, setUserPhone, setUserOtp, setUserEmail, logoutToken, setTimeRemaining } = authenticationSlice.actions;
export default authenticationSlice.reducer;
